import { useDispatch, useSelector } from 'react-redux'

import DatepickerWithLabel from '../../../../common/interactive/DatepickerWithLabel'
import InputBox from '../../../../common/interactive/InputBox'
import { caseActions } from '../../../../../store/case'
import { caseQuickUpdate } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import CheckboxCell from '../../../../common/interactive/CheckboxCell'
import { frontendOptions } from '../../../../../lib/systemData'
import { useMemo } from 'react'

import classes from '../SurgicalDrawer.module.css'
import CustomSelect from '../../../../common/interactive/CustomSelect'
import { getSurgeryRecommendedStatusValue, searchTabInCaseType } from '../../../../../lib/misc'
import GlobalTooltip from '../../../../common/GlobalTooltip'

export default function PerformingSurgeonEvaluation({itemData, apiCase}) {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const majorMeds = activeCase?.major_meds ?? []
    const hasPrimaryMajorMed = majorMeds.find((item) => item.is_primary_insurance)
    const showDeferralReason = itemData.step_5_status === 3
    const showInsuranceConfirmed =
        searchTabInCaseType(activeCase, "worker_comp") ||
        (searchTabInCaseType(activeCase, "major_med") && hasPrimaryMajorMed)
    const surgeryRecommendationOptions = useMemo(() => frontendOptions()?.surgeryRecomandation || [], [])
    const procedureSuggestions = useMemo(() => frontendOptions()?.surgeryProcedureTypes || [], [])
    const recommendedStatusValue = useMemo(() => getSurgeryRecommendedStatusValue(), [])
    const showProcedureTypeTab5 = useMemo(() => (
        searchTabInCaseType(activeCase, 'major_med')
        && itemData.step_5_status != null && itemData.step_5_status !== ''
        && Number(itemData.step_5_status) === Number(recommendedStatusValue)
    ), [activeCase, itemData.step_5_status, recommendedStatusValue])
    const deferralReasonOptions = useMemo(() => frontendOptions()?.reasonForDefferal || [], [])
    const isInsuranceConfirmedDisabled = !itemData.step_5_status || (itemData.step_5_status && itemData.step_5_status !== 4)

    const makeIdentifier = (field) => ({
        folder: 'surgeries',
        type: apiCase,
        field,
        type_id: itemData.id
    })

    const updateHandler = async (data) => {
        const reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        const dispatchBody = {
            folder: data.identifier.folder,
            item: {
                itemId: itemData.id,
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    }
                ]              
            },
        }

        if (data.identifier.field === 'step_5_status') {

            reqBody.fields.step_5_surgery_insurance_authorization_obtained = 0
            dispatchBody.item.fields.push({
                field: 'step_5_surgery_insurance_authorization_obtained',
                value: 0
            })
            const nextStatus = data.data.value
            if (nextStatus == null || nextStatus === '') {
                reqBody.fields.step_5_procedure_type = ''
                reqBody.fields.step_5_reason_for_defferal = ''
                dispatchBody.item.fields.push({
                    field: 'step_5_procedure_type',
                    value: ''
                })
                dispatchBody.item.fields.push({
                    field: 'step_5_reason_for_defferal',
                    value: ''
                })
            } else if (Number(nextStatus) !== Number(recommendedStatusValue)) {
                reqBody.fields.step_5_procedure_type = ''
                dispatchBody.item.fields.push({
                    field: 'step_5_procedure_type',
                    value: ''
                })
            }
        }

        dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))

        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            
        }        
        
    }
    return <>
        <h3 className={classes.pannel_title}>#5 Performing Surgeon Evaluation</h3>
            
        <div className={classes.drawer_row}>
            <InputBox label={'Performing Surgeon'} action={updateHandler} currentValue={itemData.step_5_performing_surgeon} identifier={makeIdentifier('step_5_performing_surgeon')}/>
        </div>

        {searchTabInCaseType(activeCase, "workers_comp") && <div className={classes.drawer_row}>
            <CheckboxCell label={'Preauthorization Obtained (WC)'} action={updateHandler} checked={itemData.step_5_preauthorization_obtainede} direction={'reverse'} identifier={makeIdentifier('step_5_preauthorization_obtainede')}/>
        </div>}

        <div className={classes.drawer_row}>
            <div className={`${classes.drawer_flex_block} ${classes.drawer_flex_block_equal}`}>
                <DatepickerWithLabel label={'Eval Appt Date'} action={updateHandler} defaultDate={itemData.step_5_eval_appt_date} identifier={makeIdentifier('step_5_eval_appt_date')} disabled={!itemData.step_2_total_funds_approved}/>
                <div className='flex-container'>
                    <DatepickerWithLabel label={'Est Surgical Date'} action={updateHandler} defaultDate={itemData.step_5_est_surgical_date} identifier={makeIdentifier('step_5_est_surgical_date')}/>
                    {!itemData.step_2_total_funds_approved ? <GlobalTooltip noMargin={true}>
                        Final Financial Approved not obtained
                    </GlobalTooltip> : null}
                </div>
            </div>            
        </div>

        {searchTabInCaseType(activeCase, "major_med") &&<div className={classes.drawer_row}>
            <CustomSelect label={'Surgical Status'} optionsData={surgeryRecommendationOptions} preSelectedValue={itemData.step_5_status} action={updateHandler} identifier={makeIdentifier('step_5_status')} hasRemove={true}/>
        </div>}    

        {showProcedureTypeTab5 ? <div className={classes.drawer_row}>
            <InputBox label={'Procedure Type'} action={updateHandler} currentValue={itemData.step_5_procedure_type || ''} identifier={makeIdentifier('step_5_procedure_type')} suggestions={procedureSuggestions}/>
        </div> : null}

        {showDeferralReason && <div className={classes.drawer_row}>
            <CustomSelect label={'Reason for deferral'} optionsData={deferralReasonOptions} preSelectedValue={itemData.step_5_reason_for_defferal} action={updateHandler} identifier={makeIdentifier('step_5_reason_for_defferal')}/>
        </div> }     


        {showInsuranceConfirmed && <>
            <div className={classes.drawer_row}>
                <div className='flex-container'>
                    <CheckboxCell label={'Insurance Confirmed'} action={updateHandler} checked={itemData.step_5_surgery_insurance_authorization_obtained} direction={'reverse'} identifier={makeIdentifier('step_5_surgery_insurance_authorization_obtained')} isDisabled={isInsuranceConfirmedDisabled}/>
                    <GlobalTooltip>
                        Only required for WC or for any other Case Type with MM available, whenever Surgery Approved.
                    </GlobalTooltip>
                </div>
            </div>
                
        </>}
        
    </>
}